import { render, staticRenderFns } from "./excel-sample.vue?vue&type=template&id=2c967eec&"
import script from "./excel-sample.vue?vue&type=script&lang=js&"
export * from "./excel-sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports